import { IconPropTypes } from '@/legacy/types';

const Info = ({ width = 24, height = 24, scale = 1, className }: IconPropTypes) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={width}
			height={height}
			viewBox='0 0 24 24'
			className={className}
			fill='none'
			scale={scale}
		>
			<g
				stroke={'currentColor'}
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeWidth={1.5}
			>
				<path d='M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11ZM9 17h6' />
				<path d='M12 17v-6h-2M12 7.346a.423.423 0 0 1 0-.846M12 7.346a.423.423 0 1 0 0-.846' />
			</g>
			<defs>
				<path
					fill='#fff'
					d='M0 0h24v24H0z'
				/>
			</defs>
		</svg>
	);
};

export default Info;
